import { Form as SemanticForm } from "semantic-ui-react";

import { FormProvider as ReactHookFormProvider, useFieldArray, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import FormPhoneInput from "astrid-web/src/features/forms/components/FormPhoneInput/FormPhoneInput";

import ErrorMessage from "../../../ui/components/Messages/ErrorMessage";

import useForm from "../../hooks/useForm";
import useFormField from "../../hooks/useFormField";
import usePartialFormValidation from "../../hooks/usePartialFormValidation";

import FormAutoSave from "../FormAutoSave/FormAutoSave";
import FormBlocker from "../FormBlocker/FormBlocker";
import FormCheckbox from "../FormCheckbox/FormCheckbox";
import FormCheckboxButton from "../FormCheckboxButton/FormCheckboxButton";
import FormCheckboxTable from "../FormCheckboxTable/FormCheckboxTable";
import FormCollectionSelect from "../FormCollectionSelect/FormCollectionSelect";
import FormDateInput from "../FormDateInput/FormDateInput";
import FormDurationInput from "../FormDurationInput/FormDurationInput";
import FormField from "../FormField/FormField";
import FormFieldArrayTable from "../FormFieldArrayTable/FormFieldArrayTable";
import FormFileInput from "../FormFileInput/FormFileInput";
import FormGroup from "../FormGroup/FormGroup";
import FormInput from "../FormInput/FormInput";
import FormLanguageSelect from "../FormLanguageSelect/FormLanguageSelect";
import FormModal from "../FormModal/FormModal";
import FormNumberInput from "../FormNumberInput/FormNumberInput";
import FormPasswordInput from "../FormPasswordInput/FormPasswordInput";
import FormRadio from "../FormRadio/FormRadio";
import FormRadioButton from "../FormRadioButton/FormRadioButton";
import FormDocumentSelect from "../FormSelect/FormDocumentSelect";
import FormInstantSearchSelect from "../FormSelect/FormInstantSearchSelect";
import FormSelect from "../FormSelect/FormSelect";
import FormTextArea from "../FormTextArea/FormTextArea";
import FormTimeInput from "../FormTimeInput/FormTimeInput";
import FormUploadButton from "../FormUploadButton/FormUploadButton";
import FormValidationMessage from "../FormValidationMessage/FormValidationMessage";

export function FormProvider({ form, ...props }) {
	return <ReactHookFormProvider {...form} {...props} />;
}

export function FormForm(props) {
	return <SemanticForm as="div" {...props} />;
}

export default function Form({ form, error, ...props }) {
	const { t } = useTranslation();

	return (
		<FormProvider {...form}>
			<FormForm {...props} />

			{error && <ErrorMessage error={error}>{t("errorMessageHeader", "Something went wrong")}</ErrorMessage>}
		</FormProvider>
	);
}

// Form
Form.Form = FormForm;
Form.FormProvider = FormProvider;
Form.AutoSave = FormAutoSave;
Form.Blocker = FormBlocker;
Form.Modal = FormModal;
Form.Group = FormGroup;
Form.ValidationMessage = FormValidationMessage;

// Semantic UI
Form.SemanticField = SemanticForm.Field;

// Fields
Form.Checkbox = FormCheckbox;
Form.DateInput = FormDateInput;
Form.TimeInput = FormTimeInput;
Form.DocumentSelect = FormDocumentSelect;
Form.InstantSearchSelect = FormInstantSearchSelect;
Form.CollectionSelect = FormCollectionSelect;
Form.Field = FormField;
Form.Input = FormInput;
Form.NumberInput = FormNumberInput;
Form.PasswordInput = FormPasswordInput;
Form.DurationInput = FormDurationInput;
Form.PhoneInput = FormPhoneInput;
Form.Radio = FormRadio;
Form.Select = FormSelect;
Form.TextArea = FormTextArea;
Form.UploadButton = FormUploadButton;
Form.LanguageSelect = FormLanguageSelect;
Form.FileInput = FormFileInput;
Form.RadioButton = FormRadioButton;
Form.CheckboxButton = FormCheckboxButton;
Form.FormFieldArrayTable = FormFieldArrayTable;
Form.FormCheckboxTable = FormCheckboxTable;

// Hooks
Form.useFieldArray = useFieldArray;
Form.useForm = useForm;
Form.useFormContext = useFormContext;
Form.useFormField = useFormField;
Form.usePartialFormValidation = usePartialFormValidation;
